import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./playerRoulette.module.css";

function PlayerCoin({ timings, image, name }) {
  const [showName, setShowName] = useState(false);
  const ROULETTE_TIME =
    timings.rotation * timings.rotation_count +
    timings.overshoot +
    timings.spring;

  useEffect(() => {
    if (name) {
      setTimeout(() => {
        setShowName(true);
      }, ROULETTE_TIME + timings.name_delay);
    }
  }, [name]);

  return (
    <div
      className={`${styles.player} ${
        showName ? styles["player-selected"] : ""
      }`}
      style={{
        "--animation-duration": `${timings.selected}ms`,
        "--animation-delay": `${
          timings.name + timings.name_delay + timings.selected_delay
        }ms`,
      }}
    >
      <img className="bg-[--primary-dark] object-cover" src={image} alt="" />
      {showName && (
        <div className="flex justify-center mt-2">
          <span
            style={{
              "--animation-duration": `${timings.name}ms`,
            }}
          >
            {name}
          </span>
        </div>
      )}
    </div>
  );
}

export default function DesafiosPlayerRoullete({ timings, player1, player2 }) {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const ROULETTE_TIME =
    timings.rotation * timings.rotation_count +
    timings.overshoot +
    timings.spring;

  useEffect(() => {
    setShow(true);
    setTimeout(() => {
      setShow(false);
    }, ROULETTE_TIME + timings.name + timings.name_delay + timings.selected_delay + timings.fade);
  }, [player1, player2]);

  return show ? (
    <div
      className={styles.container}
      style={{
        "--animation-delay": `${
          ROULETTE_TIME +
          timings.name +
          timings.name_delay +
          timings.selected_delay
        }ms`,
        "--animation-duration": `${timings.fade}ms`,
      }}
    >
      <div className="flex-1 h-full">
        <div className={styles["linear-top"]}></div>
        <div className={`${styles.content}`}>
          <h2 className="font-bold text-2xl">{t("selecionajoagador")}</h2>
          <div
            className={styles.players}
            style={{
              "--rotation-count": `${timings.rotation_count}`,
              "--rotation-duration": `${timings.rotation}ms`,
              "--overshoot-duration": `${timings.overshoot}ms`,
              "--spring-duration": `${timings.spring}ms`,
            }}
          >
            <PlayerCoin
              timings={timings}
              image={`https://desafios-picantes-bucket.dev12br.com${player2.image}`}
            />
            <PlayerCoin
              timings={timings}
              image={`https://desafios-picantes-bucket.dev12br.com${player1.image}`}
              name={player1.name}
            />
            <PlayerCoin
              timings={timings}
              image={`https://desafios-picantes-bucket.dev12br.com${player2.image}`}
            />
            <PlayerCoin
              timings={timings}
              image={`https://desafios-picantes-bucket.dev12br.com${player1.image}`}
            />
          </div>
        </div>
        <div className={styles["linear-bottom"]}></div>
      </div>
    </div>
  ) : null;
}
